<template>
    <div>

        <div v-if="content">
            <div class="card rounded flex flex-col items-center">
                <a
                    v-if="externalLink"
                    :href="link"
                    class="block w-full card--hover"
                >
                    <CatalogueTileImage
                        v-if="image"
                        :image="image"
                        :hover-image="hoverImage"
                        :medium-image="mediumImage"
                        :small-image="smallImage"
                        :half-image="halfImage"
                        :is-new="isNew"
                        :lazy="lazy"
                    />
                </a>
                <nuxt-link
                    v-else
                    :to="link"
                    class="block w-full"
                >
                    <CatalogueTileImage
                        v-if="image"
                        :image="image"
                        :hover-image="hoverImage"
                        :medium-image="mediumImage"
                        :small-image="smallImage"
                        :half-image="halfImage"
                        :is-new="isNew"
                        :lazy="lazy"
                    />
                </nuxt-link>
                <div
                    class="pt-2 block page-tile-content"
                    v-html="content"
                />

                <ShippingClassAddressChecker
                    v-if="showPostcodeChecker && shippingClassId"
                    :shipping-class-id="shippingClassId"
                />
            </div>
        </div>
        <div
            v-else-if="externalLink"
        >
            <a
                :href="link"
                class="block w-full"
            >
                <CatalogueTileImage
                    v-if="image"
                    :image="image"
                    :hover-image="hoverImage"
                    :medium-image="mediumImage"
                    :small-image="smallImage"
                    :half-image="halfImage"
                    :is-new="isNew"
                    :lazy="lazy"
                />
            </a>
        </div>
        <div
            v-else
        >
            <nuxt-link
                :to="link"
                class="block w-full"
            >
                <CatalogueTileImage
                    v-if="image"
                    :image="image"
                    :hover-image="hoverImage"
                    :medium-image="mediumImage"
                    :small-image="smallImage"
                    :half-image="halfImage"
                    :is-new="isNew"
                    :lazy="lazy"
                />
            </nuxt-link>
        </div>

    </div>
</template>

<script>
import CatalogueTileImage from './CatalogueTileImage';
import ProductAddressChecker from './ProductAddressChecker';
import ShippingClassAddressChecker from '@/components/ShippingClassAddressChecker.vue';

export default {

    components: {
        ShippingClassAddressChecker,
        CatalogueTileImage,
        ProductAddressChecker,
    },

    props: {
        image: {
            type: String,
            default: null,
        },
        hoverImage: {
            type: String,
            default: null,
        },
        mediumImage: {
            type: String,
            default: null,
        },
        smallImage: {
            type: String,
            default: null,
        },
        title: {
            type: String,
            required: true,
        },
        link: {
            type: String,
            required: true,
        },
        externalLink: {
            type: Boolean,
            default: false,
        },
        isNew: {
            type: Boolean,
            default: false,
        },
        halfImage: {
            type: Boolean,
            default: false,
        },
        content: {
            type: String,
            default: null,
        },
        lazy: {
            type: Boolean,
            default: true,
        },
        showPostcodeChecker: {
            type: Boolean,
            default: false,
        },
        shippingClassId: {
            type: Number,
            default: null,
        },
    },

};
</script>

<style lang="scss" scoped>
.card {
    @apply overflow-hidden relative select-none transition-fast;

    &:hover {
        .card__new-banner {
            @apply opacity-0;
        }

        .card__image--hover {
            @apply opacity-100;
        }
    }

    &__new-banner {
        @apply absolute bg-primary py-2 text-center text-white font-bold transition-slow z-20;
        transform: rotate(-45deg);
        top: 10px;
        left: -70px;
        width: 200px;

        &:after {
            content: "";
            left: 0;
            top: -98%;
            @apply bg-primary absolute w-full h-full;
        }
    }

    &__image {
        object-fit: cover;
        object-position: center;
        @apply block w-full transition-fast;

        &--hover {
            @apply absolute opacity-0 transition-slow z-10 w-full;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
        }
    }
}
</style>
